import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { IndustryProblem } from "./components/IndustryProblem";
import { FeaturesTeaser } from "./components/FeaturesTeaser";
import { RolesGrid } from "./components/RolesGrid";
import { Mission } from "./components/Mission";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import PilotPage from "./pages/PilotPage";
import FeaturesPage from "./pages/FeaturesPage";
import TermsPage from "./pages/TermsPage";
import { AnalyticsTracker } from "./components/AnalyticsTracker";

const Landing = () => (
  <main data-testid="landing-page" className="relative bg-loudar-ink text-white">
    <Nav />
    <Hero />
    <FeaturesTeaser />
    <IndustryProblem />
    <RolesGrid />
    <Mission />
    <FinalCTA />
    <Footer />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pilot" element={<PilotPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
